export default "__VITE_ASSET__C_KX7Aqr__"